(function () {
    'use strict';
    /**
     * Module for IBCOSE2 view 
     */
    angular.module('ib-checkin-ib-plus', []);
})();